import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47c08422"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "c_cell_info"
};
const _hoisted_2 = {
  class: "cell-info-left"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "cell-info-right"
};
const _hoisted_5 = {
  class: "cell-info-right-top"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 1,
  class: "cell-info-right-bottom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cellData, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "cell-info-item",
      key: item.name
    }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
      src: item.src,
      alt: ""
    }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1), item.link ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "cell-info-right-bottom cursor",
      onClick: $event => _ctx.$router.push(item.link)
    }, [_createElementVNode("div", null, _toDisplayString(item.value), 1)], 8, _hoisted_6)) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", null, _toDisplayString(item.value), 1)]))])]);
  }), 128))]);
}